import { render, staticRenderFns } from "./view3d.vue?vue&type=template&id=52b49b49&scoped=true"
import script from "./view3d.vue?vue&type=script&lang=js"
export * from "./view3d.vue?vue&type=script&lang=js"
import style0 from "./view3d.vue?vue&type=style&index=0&id=52b49b49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b49b49",
  null
  
)

export default component.exports